import * as z from "zod";

export const ConfirmProductVisualizationSchema = z.object({
  productId: z.string(),
  productImageUrl: z.url(),
});
export type ConfirmProductVisualization = z.infer<
  typeof ConfirmProductVisualizationSchema
>;
